
export enum SessionsRouteItems {
  Projects = `projects`,
  ProjectIdParam = `:projectId`,
  GameEnvironmentIdParam = `:gameEnvironmentId`,
  Sessions = 'sessions'
}
